import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	requiredFieldsInstructionText: {
		// eslint-disable-next-line jira/i18n/id-named-by-package -- PLEASE FIX THIS SUPPRESSION
		id: 'servicedesk-widget-settings.content.settings-form-v2.required-field-text',
		defaultMessage: 'Required fields are marked with an asterisk',
		description:
			'An instruction message indcating users that fields marked with an asteriks (*) are required',
	},
	basicWidgetLabel: {
		id: 'servicedesk-widget-settings.content.settings-form-v2.basic-widget-label',
		defaultMessage: 'Basic widget',
		description:
			'Label for Basic Widget radio option, this will tell the user what type of widget they are selecting',
	},
	basicWidgetDescription: {
		id: 'servicedesk-widget-settings.content.settings-form-v2.basic-widget-description',
		defaultMessage: 'Customer can raise requests using the default request types.',
		description:
			'Description for Basic Widget radio option, this will tell the user what the basic widget does',
	},
	virtualServiceAgentLabel: {
		id: 'servicedesk-widget-settings.content.settings-form-v2.virtual-service-agent-label',
		defaultMessage: 'Virtual service agent',
		description:
			'Label for virtual service agent enabled Widget radio option, this will tell the user that they have selected a VA enabled widget.',
	},
	virtualAgentLabel: {
		id: 'servicedesk-widget-settings.content.settings-form-v2.virtual-agent-label',
		defaultMessage: 'Virtual agent',
		description:
			'Label for virtual agent enabled Widget radio option, this will tell the user that they have selected a VA enabled widget.',
	},
	virtualAgentBetaLabel: {
		id: 'servicedesk-widget-settings.content.settings-form-v2.virtual-agent-beta-label',
		defaultMessage: 'beta',
		description:
			'Beta label for virtual service agent enabled Widget radio option, this will tell the user that this is a beta feature.',
	},
	virtualAgentDescription: {
		id: 'servicedesk-widget-settings.content.settings-form-v2.virtual-agent-description',
		defaultMessage:
			'A conversational support tool that learns to recognize questions {br} and requests, then automatically responds and takes action.',
		description:
			'Description for Virutal Agent radio option, this will tell the user what the basic widget does',
	},
	virtualAgentTooltipConfigureLinkLabel: {
		// eslint-disable-next-line jira/i18n/id-named-by-package -- PLEASE FIX THIS SUPPRESSION
		id: 'servicedesk-widget-settings.content.settings-form-v2.virtual-agent-tooltip-link-label',
		defaultMessage: 'configure your virtual agent',
		description:
			'Label for the virtual agent tooltip, this will prompt the user to configure their virtual agent',
	},
	virtualServiceAgentTooltipConfigureLinkLabel: {
		id: 'servicedesk-widget-settings.content.settings-form-v2.virtual-service-agent-tooltip-configure-link-label',
		defaultMessage: 'configure your virtual service agent',
		description:
			'Label for the virtual service agent tooltip, this will prompt the user to configure their virtual service agent',
	},
	virtualServiceAgentTooltipConfigureHeadingLabel: {
		id: 'servicedesk-widget-settings.content.settings-form-v2.virtual-service-agent-tooltip-configure-heading-label',
		defaultMessage: 'Configure your virtual service agent',
		description:
			'Label on the virtual service agent radio box, this will allow the user to configure their virtual service agent',
	},
	virtualAgentTooltipConfigureHeadingLabel: {
		// eslint-disable-next-line jira/i18n/id-named-by-package -- PLEASE FIX THIS SUPPRESSION
		id: 'servicedesk-widget-settings.content.settings-form-v2.virtual-agent-heading-link-label',
		defaultMessage: 'Configure your virtual agent',
		description:
			'Label on the virtual agent radio box, this will allow the user to configure their virtual agent',
	},
	virtualServiceAgentTooltipLabel: {
		id: 'servicedesk-widget-settings.content.settings-form-v2.virtual-service-agent-tooltip-label',
		defaultMessage: 'To use the virtual service agent in the widget, ',
		description:
			'Label for the virtual service agent tooltip, this will propmt user to configure their virtual service agent',
	},
	virtualAgentTooltipLabel: {
		id: 'servicedesk-widget-settings.content.settings-form-v2.virtual-agent-tooltip-label',
		defaultMessage: 'To use the virtual agent in the widget, ',
		description:
			'Label for the virtual agent tooltip, this will propmt user to configure their virtual agent',
	},
	defaultRequestTypeSelectLabel: {
		id: 'servicedesk-widget-settings.content.settings-form-v2.default-request-type-select-label',
		defaultMessage: 'Default request type',
		description:
			'Label for the default request type select, which allows the user to select the default request type to be displayed in the widget',
	},
	defaultRequestTypeSelectHelpTextV2: {
		id: 'servicedesk-widget-settings.content.settings-form-v2.default-request-type-select-help-text-v-2',
		defaultMessage:
			'Customers use this to raise requests if they can’t get the help they need from the basic widget or if the virtual service agent stops working.',
		description:
			'Help text for the default request type select, explaining what the default request type is for',
	},
	defaultRequestTypeSelectHelpText: {
		id: 'servicedesk-widget-settings.content.settings-form-v2.default-request-type-select-help-text',
		defaultMessage:
			'Customers use this to raise requests if they can’t get the help they need from the basic widget or if the virtual agent stops working.',
		description:
			'Help text for the default request type select, explaining what the default request type is for',
	},
	allowSearchForAllRequestTypesToggleLabel: {
		id: 'servicedesk-widget-settings.content.settings-form-v2.allow-search-for-all-request-types-toggle-label',
		defaultMessage: 'Allow search for other request types',
		description:
			'Label for Request Type toggle. Turning this on will allow users to search for other request types inside widget',
	},
	allowSearchForKnowledgeBaseArticlesToggleLabel: {
		id: 'servicedesk-widget-settings.content.settings-form-v2.allow-search-for-knowledge-base-articles-toggle-label',
		defaultMessage: 'Allow search for knowledge base articles',
		description:
			'Label for Knowledge base articles toggles. Turning this on will allow users to search for Knowledge base articles inside widgets',
	},
	allowSearchForKnowledgeBaseArticlesToggleHelpText: {
		id: 'servicedesk-widget-settings.content.settings-form-v2.allow-search-for-knowledge-base-articles-toggle-help-text',
		defaultMessage: "Make sure 'Viewing' access is set to 'Anyone' in knowledge base settings",
		description:
			'Help text for the allow search for knowledge base articles toggle, explaining what the user needs to do to enable this feature',
	},
	colorInputLabel: {
		id: 'servicedesk-widget-settings.content.settings-form-v2.color-input-label',
		defaultMessage: 'Color',
		description:
			'Label for the color input, which allows the user to select the theme color of the widget',
	},
	colorInputErrorMessage: {
		id: 'servicedesk-widget-settings.content.settings-form-v2.color-input-error-message',
		defaultMessage: 'Enter a valid color code',
		description:
			'Error message for the color input, displayed when the user enters an invalid color code which is not a valid hex color',
	},
	widgetBackgroundPatternSelectLabel: {
		id: 'servicedesk-widget-settings.content.settings-form-v2.widget-background-pattern-select-label',
		defaultMessage: 'Background pattern',
		description:
			'Label for the widget background pattern select, which allows the user to select the background pattern of the widget from a list of available patterns',
	},
	widgetButtonTypeRadioGroupLabel: {
		id: 'servicedesk-widget-settings.content.settings-form-v2.widget-button-type-radio-group-label',
		defaultMessage: 'Button type',
		description:
			'Label for the widget button type radio group, which allows the user to select the type of button to be displayed in the widget. The available options are: question mark icon, custom text. Selecting custom text enables the custom text input',
	},
	widgetButtonQuestionMarkIconRadioLabel: {
		id: 'servicedesk-widget-settings.content.settings-form-v2.widget-button-question-mark-icon-radio-label',
		defaultMessage: 'Question mark icon',
		description:
			'Label for the widget button question mark icon radio option, which displays a question mark icon in the widget button',
	},
	widgetButtonCustomTextRadioLabel: {
		id: 'servicedesk-widget-settings.content.settings-form-v2.widget-button-custom-text-radio-label',
		defaultMessage: 'Custom button text',
		description:
			'Label for the widget button custom text input which is displayed when selecting the custom text radio option, which allows the user to enter custom text to be displayed in the widget button',
	},
	widgetButtonCustomTextInputLabel: {
		id: 'servicedesk-widget-settings.content.settings-form-v2.widget-button-custom-text-input-label',
		defaultMessage: 'Custom text',
		description:
			'Label for the widget button custom text input, which allows the user to enter custom text to be displayed in the widget button',
	},
	widgetHeaderInputLabel: {
		id: 'servicedesk-widget-settings.content.settings-form-v2.widget-header-input-label',
		defaultMessage: 'Header',
		description:
			'Label for the widget header input, which allows the user to enter a custom header to be displayed in the title of the widget',
	},
	widgetHeaderFieldCaptionLabel: {
		id: 'servicedesk-widget-settings.content.settings-form-v2.widget-header-field-caption-label',
		defaultMessage: 'This appears at the top of the widget window',
		description:
			'Helper text that appears below the widget header text input field. Indicates the location where this header text will be displayed.',
	},
	confirmationMessageInputLabel: {
		id: 'servicedesk-widget-settings.content.settings-form-v2.confirmation-message-input-label',
		defaultMessage: 'Confirmation message',
		description:
			'Label for the confirmation message input, which allows the user to enter a custom confirmation message to be displayed after the user submits a request',
	},
	widgetConfirmationCaptionLabel: {
		// eslint-disable-next-line jira/i18n/id-named-by-package -- PLEASE FIX THIS SUPPRESSION
		id: 'servicedesk-widget-settings.content.settings-form-v2.confirmation-text-caption-label',
		defaultMessage: 'Customers see this message after they raise a request.',
		description:
			'Helper text below confirmation text field that indicates when this field will be visible',
	},
	hideWidgetCheckboxLabel: {
		id: 'servicedesk-widget-settings.content.settings-form-v2.hide-widget-checkbox-label',
		defaultMessage: 'Hide widget',
		description:
			'Label for the hide widget toggle, which enables or disables the loading of the widget in the page where it is embedded',
	},
	hiddenWidgetBadgeLabel: {
		// eslint-disable-next-line jira/i18n/id-named-by-package -- PLEASE FIX THIS SUPPRESSION
		id: 'servicedesk-widget-settings.content.settings-form-v2.hide-widget-badge',
		defaultMessage: 'Hidden',
		description:
			'Lable for showing that widget is hidden. This will appear on the header of the expand accordion',
	},
	hideWidgetCheckboxDescription: {
		id: 'servicedesk-widget-settings.content.settings-form-v2.hide-widget-checkbox-description',
		defaultMessage: 'Prevent the widget from appearing on any websites where it’s embedded.',
		description: 'The message yet not been finalized and therefore marked with a non-final suffix.',
	},
	saveButtonLabel: {
		id: 'servicedesk-widget-settings.content.settings-form-v2.save-button-label',
		defaultMessage: 'Save',
		description:
			'Label for the save button, which saves the widget settings and shows the embed code section',
	},
	cancelButtonLabel: {
		id: 'servicedesk-widget-settings.content.settings-form-v2.cancel-button-label',
		defaultMessage: 'Cancel',
		description:
			'Label for the cancel button, which cancels the widget settings and resets the form to last saved values',
	},
	saveSuccessFlagHeading: {
		// eslint-disable-next-line jira/i18n/id-named-by-package -- PLEASE FIX THIS SUPPRESSION
		id: 'servicedesk-widget-settings.content.settings-form-v2.save-success-flag-heading-message',
		defaultMessage: 'We’ve saved your changes',
		description: 'Message displayed in the flag when the widget settings are saved successfully',
	},
	saveSuccessFlagDescription: {
		// eslint-disable-next-line jira/i18n/id-named-by-package -- PLEASE FIX THIS SUPPRESSION
		id: 'servicedesk-widget-settings.content.settings-form-v2.save-success-flag-description-message',
		defaultMessage: 'Widget configuration have been updated successfully.',
		description:
			'Description displayed in the flag when the widget settings are saved successfully',
	},
	errorBlankValue: {
		id: 'servicedesk-widget-settings.content.settings-form-v2.error-blank-value',
		defaultMessage: 'Enter a {fieldName}',
		description:
			'Error message for blank value, displayed when the user leaves a required field blank. Used for all required text input fields',
	},
	errorMaxLength: {
		id: 'servicedesk-widget-settings.content.settings-form-v2.error-max-length',
		defaultMessage: "{fieldName} can't exceed {length} characters.",
		description:
			'Error message for maximum length exceeded, displayed when the user enters a value which exceeds the maximum length allowed for a field',
	},
	errorFetchingRequestTypes: {
		id: 'servicedesk-widget-settings.content.settings-form-v2.error-fetching-request-types',
		defaultMessage: "We can't load the request types right now. Try again in a little while.",
		description:
			'Error message displayed when there is an error fetching request types from the backend',
	},
	formAriaLabel: {
		id: 'servicedesk-widget-settings.content.settings-form-v2.form-aria-label',
		defaultMessage:
			'The changes you make in the form input fields will be reflected in the Preview',
		description:
			'Aria label for the widget settings form, which is used to describe the form to screen readers',
	},
	supportExperienceHeading: {
		id: 'servicedesk-widget-settings.content.settings-form-v2.support-experience-heading',
		defaultMessage: 'Support experience',
		description: 'Heading for the support experience section',
	},
	defaultRequestTypeHeading: {
		id: 'servicedesk-widget-settings.content.settings-form-v2.default-request-type-heading',
		defaultMessage: 'Default request type',
		description: 'Heading for the default request type collapsible section',
	},
	lookAndFeelHeading: {
		id: 'servicedesk-widget-settings.content.settings-form-v2.look-and-feel-heading',
		defaultMessage: 'Look and feel',
		description: 'Heading for the Look and feel collapsible section',
	},
	embedCodeHeading: {
		id: 'servicedesk-widget-settings.content.settings-form-v2.embed-code-heading',
		defaultMessage: 'Embed code',
		description: 'Heading for the Embed code collapsible section',
	},
	hideWidgetHeading: {
		id: 'servicedesk-widget-settings.content.settings-form-v2.hide-widget-heading',
		defaultMessage: 'Hide widget',
		description: 'Heading for the hide widget collapsible section',
	},
});
